import { render } from "./Commercial.vue?vue&type=template&id=7af412ad&scoped=true"
import script from "./Commercial.vue?vue&type=script&lang=js"
export * from "./Commercial.vue?vue&type=script&lang=js"

import "./Commercial.vue?vue&type=style&index=0&id=7af412ad&scoped=true&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af412ad"]])

export default __exports__